export default "__VITE_ASSET__BYPFDyHU__"